var React = require('react');

function Parkering (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"53","y":"53","width":"86","height":"86","rx":"3","stroke":"#000","strokeWidth":"4","key":0}),React.createElement("rect",{"x":"42","y":"42","width":"108","height":"108","rx":"3","stroke":"#000","strokeWidth":"4","key":1}),React.createElement("path",{"d":"M86 119V96.6m0 0V77.2c12.7 0 24-2.4 24 9.5s-16 9.6-24 9.9Z","stroke":"#000","strokeWidth":"8","key":2})]);
}

Parkering.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = Parkering;

Parkering.default = Parkering;
